import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const drawerWidth = 340;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
}));

export default function FullScreenDialog(props) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div>
      <Dialog
        fullScreen
        open={props.show}
        onClose={props.handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={clsx(classes.appBar)} sx={{ position: "relative", backgroundColor: "#262349" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {props.heading}
            </Typography>
            {props.showSecondarySaveButton ? (
              <Button
                autoFocus
                color="inherit"
                onClick={props.onSecondarySaveButtonClick}
              >
                {props.secondarySaveButtonText}
              </Button>
            ) : (
              ""
            )}
            {props.showSaveButton ? (
              <Button
                autoFocus
                color="inherit"
                onClick={props.onSumitSaveButton}
              >
                {props.saveButtonText}
              </Button>
            ) : (
              ""
            )}
          </Toolbar>
        </AppBar>
        {props.inputProps}
      </Dialog>
    </div>
  );
}
